import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { ButtonGroup, Popper, Grow, Paper, ClickAwayListener, MenuList } from '@material-ui/core';
import { WideArrowDownward } from '../../icons';
import { Button } from '../Button';
import { useDevice } from '../Device';
import { useOverlayContext } from '../OverlayContext';
import { useSplitButtonStyles } from './SplitButton.styles';
import { getTestId } from './SplitButton.utils';
export function SplitButton(props) {
    const { label, children, placement, modifiers, popperClassName } = props, rest = _object_without_properties(props, [
        "label",
        "children",
        "placement",
        "modifiers",
        "popperClassName"
    ]);
    const { isMobileDevice } = useDevice();
    const { pushBottomSheetPage, popBottomSheetPage } = useOverlayContext();
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);
    const testId = getTestId(props.testId);
    const overrides = useSplitButtonStyles();
    function handleMobileClick() {
        const clonedChildren = React.Children.map(children, (child)=>{
            return /*#__PURE__*/ React.isValidElement(child) ? /*#__PURE__*/ React.cloneElement(child, _object_spread_props(_object_spread({}, child.props), {
                onClick: ()=>{
                    var _child_props_onClick, _child_props;
                    popBottomSheetPage();
                    (_child_props_onClick = (_child_props = child.props).onClick) === null || _child_props_onClick === void 0 ? void 0 : _child_props_onClick.call(_child_props);
                }
            })) : child;
        });
        pushBottomSheetPage({
            content: clonedChildren
        });
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(ButtonGroup, {
                "data-testid": testId,
                variant: "contained",
                ref: anchorRef,
                className: overrides.buttonGroup,
                children: [
                    /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({}, rest), {
                        testId: "".concat(testId, "-main"),
                        children: label
                    })),
                    /*#__PURE__*/ _jsx(Button, {
                        className: overrides.toggleBtn,
                        onClick: isMobileDevice ? handleMobileClick : ()=>setOpen((prev)=>!prev),
                        testId: "".concat(testId, "-arrow"),
                        children: /*#__PURE__*/ _jsx(WideArrowDownward, {})
                    })
                ]
            }),
            !isMobileDevice && /*#__PURE__*/ _jsx(Popper, {
                open: open,
                anchorEl: anchorRef.current,
                transition: true,
                disablePortal: true,
                className: popperClassName || overrides.popperZIndex,
                placement: placement || 'bottom-end',
                modifiers: modifiers,
                children: (param)=>{
                    let { TransitionProps, placement } = param;
                    return /*#__PURE__*/ _jsx(Grow, _object_spread_props(_object_spread({}, TransitionProps), {
                        style: {
                            transformOrigin: placement.includes('bottom') ? 'center top' : 'center bottom'
                        },
                        children: /*#__PURE__*/ _jsx(Paper, {
                            className: overrides.paper,
                            children: /*#__PURE__*/ _jsx(ClickAwayListener, {
                                onClickAway: ()=>setOpen(false),
                                children: /*#__PURE__*/ _jsx(MenuList, {
                                    className: overrides.menuList,
                                    children: children
                                })
                            })
                        })
                    }));
                }
            })
        ]
    });
}
